import React from 'react';
import { components } from 'react-select';

import questionService from '../../services/QuestionService';

import FeedbackIcon from '../FeedbackIcon';

const MultiSelectValueLabel = (props) => {
  const { data, selectProps } = props;
  const answerId = questionService.getPickAnswerId(data) || data?.originalData?.id || data?.value;
  const showAnswerFeedback = !!selectProps?.showAnswerFeedback;

  return (
    <components.MultiValueLabel {...props}>
      <span className='player-select-multi-value-label'>
        {props.children}
        {showAnswerFeedback && (
          <FeedbackIcon
            answerId={answerId}
            feedbackIconSvgHeight='16'
            feedbackIconSvgTransform='translate(0, 0)'
            feedbackIconSvgWidth='16'
            lessonElementId={selectProps.lessonElementId}
            lessonElementState={selectProps.lessonElementState}
            model={selectProps.model}
            promptId={data?.dataId} />
        )}
      </span>
    </components.MultiValueLabel>
  );
};

export default MultiSelectValueLabel;
